__webpack_require__.p = "https://cdn.protico.io/static/protico/0c2d88e3462980d1dd3df8a7418476507b3ee3b8/";